/**
 * Fitnesspilot
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SportFromJSON, SportToJSON } from "./Sport";
/**
 * Check if a given object implements the SportsSummaryResponse interface.
 */
export function instanceOfSportsSummaryResponse(value) {
    if (!("sports" in value) || value.sports === undefined)
        return false;
    return true;
}
export function SportsSummaryResponseFromJSON(json) {
    return SportsSummaryResponseFromJSONTyped(json, false);
}
export function SportsSummaryResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        sports: json.sports.map(SportFromJSON),
    };
}
export function SportsSummaryResponseToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        sports: value.sports.map(SportToJSON),
    };
}
